(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["linen-batch-bar"] && !Shopify.designMode) return;
  try {
    class LinenPreorderCard extends HTMLElement {
    connectedCallback() {
      // Rolling dates from the visitor's clock: batch 2 is always N days out,
      // batch 3 follows it by the configured gap. Overwrites the server paint,
      // so cached pages still show fresh dates.
      const days2 = parseInt(this.dataset.days2, 10) || 2;
      const gap3 = parseInt(this.dataset.gap3, 10) || 14;
      const fmt = (d) => {
        const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        const day = d.getDate();
        const suffix = (day % 10 === 1 && day !== 11) ? 'st'
          : (day % 10 === 2 && day !== 12) ? 'nd'
          : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
        return months[d.getMonth()] + ' ' + day + suffix;
      };
      const d2 = new Date(Date.now() + days2 * 86400000);
      const d3 = new Date(d2.getTime() + gap3 * 86400000);
      const el2 = this.querySelector('[data-role="batch2-date"]');
      const el3 = this.querySelector('[data-role="batch3-date"]');
      if (el2) el2.textContent = fmt(d2);
      if (el3) el3.textContent = fmt(d3);
    }
  }

  if (!customElements.get('linen-preorder-card')) {
    customElements.define('linen-preorder-card', LinenPreorderCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linen-bundle-ladder"] && !Shopify.designMode) return;
  try {
    class LinenBundleLadder extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.linen-ladder__card'));
      if (!this.cards.length) return;

      const raw = this.querySelector('[data-linen-data]');
      let data = { options: [], variants: [] };
      if (raw) {
        try { data = JSON.parse(raw.textContent); } catch (e) { /* leave empty */ }
      }
      this.optionNames = (data.options || []).map((o) => o.name);
      this.variants = data.variants || [];

      const currency = this.dataset.currency || 'USD';
      const locale = document.documentElement.lang || 'en';
      const whole = new Intl.NumberFormat(locale, {
        style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0,
      });
      const cents = new Intl.NumberFormat(locale, {
        style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
      // Whole amounts read as $89, anything with cents keeps both digits ($160.20, never $160.2).
      this.money = (v) => (Math.round(v * 100) % 100 === 0 ? whole : cents).format(v);

      this.percentMode = this.dataset.savingsMode === 'percent';
      this.section = this.closest('.shopify-section') || document;
      this.form = this.closest('form[action*="/cart/add"]') || this.section.querySelector('form[action*="/cart/add"]');
      this.formComponent = this.section.querySelector('product-form-component');
      this.picker = this.section.querySelector('variant-picker');
      this.setsWrap = this.querySelector('[data-role="sets"]');

      // Two things add a single line if left alone: the theme's delegated on:submit
      // handler, and the Slide Cart app embed, which watches form submits at window
      // capture and posts its own XHR add. Disarm the theme handler, and intercept
      // the click on the button itself so the submit event never fires at all. The
      // click runs before the browser turns it into a submit, so preventDefault here
      // silences both. The theme's fly-to-cart animation is a document capture click
      // handler and has already run by then, so it is kept.
      this.disarmNativeSubmit();
      const atcBtn = this.form ? this.form.querySelector('[ref="addToCartButton"]') : null;
      if (atcBtn && !atcBtn.dataset.linenOwned) {
        atcBtn.dataset.linenOwned = 'true';
        atcBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }
      if (this.form && !this.form.dataset.linenOwned) {
        this.form.dataset.linenOwned = 'true';
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.addToCart();
        });
      }

      const defCard = this.querySelector('.linen-ladder__card.is-selected') || this.cards[0];
      this.qty = parseInt(defCard.dataset.qty, 10) || 1;
      this.maxQty = Math.max.apply(null, this.cards.map((c) => parseInt(c.dataset.qty, 10) || 1));

      const init = this.initialSelection();
      this.sets = [];
      for (let i = 0; i < this.maxQty; i++) {
        this.sets.push({ opts: Object.assign({}, init), touched: false });
      }

      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.selectTier(card));
      });

      if (this.setsWrap) {
        this.setsWrap.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-opt-value]');
          if (!btn) return;
          const panel = btn.closest('[data-set]');
          if (!panel) return;
          this.pickValue(parseInt(panel.dataset.set, 10) - 1, btn.dataset.optName, btn.dataset.optValue);
        });
      }

      // Keep SET 1 in step with the hidden native picker. Its radios are the source
      // of the URL variant preselect, and every proxied click morphs them back in.
      if (this.picker && !this.picker.dataset.linenWatched) {
        this.picker.dataset.linenWatched = 'true';
        this.picker.addEventListener('change', () => this.syncFromPicker());
      }

      this.render();
    }

    disarmNativeSubmit() {
      if (this.formComponent) this.formComponent.removeAttribute('on:submit');
    }

    pickerRadios(optName) {
      if (!this.picker) return [];
      const prefix = optName + '-';
      return Array.from(this.picker.querySelectorAll('input[type="radio"]')).filter(
        (r) => r.name && r.name.indexOf(prefix) === 0
      );
    }

    initialSelection() {
      const sel = {};
      this.optionNames.forEach((name) => {
        const checked = this.pickerRadios(name).find((r) => r.checked);
        if (checked) sel[name] = checked.value;
      });
      if (Object.keys(sel).length !== this.optionNames.length) {
        const v = this.variants.find((x) => x.a) || this.variants[0];
        if (v) {
          this.optionNames.forEach((name, i) => {
            if (!(name in sel)) sel[name] = v.o[i];
          });
        }
      }
      return sel;
    }

    syncFromPicker() {
      let changed = false;
      this.optionNames.forEach((name) => {
        const checked = this.pickerRadios(name).find((r) => r.checked);
        if (checked && this.sets[0].opts[name] !== checked.value) {
          this.sets[0].opts[name] = checked.value;
          changed = true;
        }
      });
      if (changed) {
        this.mirror();
        this.render();
      }
    }

    mirror() {
      for (let i = 1; i < this.sets.length; i++) {
        if (!this.sets[i].touched) this.sets[i].opts = Object.assign({}, this.sets[0].opts);
      }
    }

    pickValue(setIdx, optName, value) {
      const set = this.sets[setIdx];
      if (!set) return;
      set.opts[optName] = value;
      if (setIdx === 0) {
        this.mirror();
        // Route SET 1 through the hidden native picker so the price block, the
        // media gallery and the buy button all keep their native behaviour.
        const radio = this.pickerRadios(optName).find((r) => r.value === value);
        if (radio && !radio.checked) radio.click();
      } else {
        set.touched = true;
      }
      this.render();
    }

    selectTier(card) {
      this.cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.qty = parseInt(card.dataset.qty, 10) || 1;
      this.render();
    }

    variantFor(opts) {
      return this.variants.find((v) => this.optionNames.every((name, i) => v.o[i] === opts[name]));
    }

    tierPricing(q, pct, amountSave) {
      let gross = 0;
      let save = 0;
      for (let i = 0; i < q; i++) {
        const set = this.sets[i] || this.sets[0];
        const v = set ? this.variantFor(set.opts) : null;
        if (!v) continue;
        gross += v.p;
        if (this.percentMode) {
          // Shopify rounds the percentage discount per line, so mirror that here
          // and the number on the card is exactly what the cart will charge.
          save += Math.round((v.p * pct) / 100);
        }
      }
      if (!this.percentMode) save = Math.round(amountSave * 100);
      return { gross, save, net: Math.max(0, gross - save) };
    }

    render() {
      this.disarmNativeSubmit();

      const showUnit = this.dataset.showUnit === 'true';
      const showTotal = this.dataset.showTotal === 'true';
      const perSetLabel = this.dataset.perSetLabel || '/ set';
      const saveLabel = this.dataset.saveLabel || 'Save';

      this.cards.forEach((card) => {
        const q = parseInt(card.dataset.qty, 10) || 1;
        const pct = parseFloat(card.dataset.percent) || 0;
        const amt = parseFloat(card.dataset.savings) || 0;
        const p = this.tierPricing(q, pct, amt);

        const grossEl = card.querySelector('[data-role="gross"]');
        if (grossEl) grossEl.textContent = p.save > 0 ? this.money(p.gross / 100) : '';

        const totalEl = card.querySelector('[data-role="total"]');
        if (totalEl && showTotal) totalEl.textContent = this.money(p.net / 100);

        const saveEl = card.querySelector('[data-role="save"]');
        if (saveEl) saveEl.textContent = p.save > 0 ? saveLabel + ' ' + this.money(p.save / 100) : '';

        const unitEl = card.querySelector('[data-role="unit"]');
        if (unitEl && showUnit) unitEl.textContent = this.money(p.net / q / 100) + ' ' + perSetLabel;
      });

      const tierName = this.querySelector('[data-role="tier-name"]');
      if (tierName) {
        const word = this.qty === 1 ? (this.dataset.unitSingular || 'Set') : (this.dataset.unitPlural || 'Sets');
        tierName.textContent = this.qty + ' ' + word;
      }

      if (this.setsWrap) {
        this.setsWrap.classList.toggle('is-single', this.qty === 1);
        this.setsWrap.querySelectorAll('[data-set]').forEach((panel) => {
          const idx = parseInt(panel.dataset.set, 10) - 1;
          panel.classList.toggle('is-hidden', idx >= this.qty);
          const set = this.sets[idx];
          if (!set) return;

          panel.querySelectorAll('[data-opt-value]').forEach((btn) => {
            const on = set.opts[btn.dataset.optName] === btn.dataset.optValue;
            btn.classList.toggle('is-selected', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          panel.querySelectorAll('[data-role="optvalue"]').forEach((el) => {
            el.textContent = set.opts[el.dataset.optName] || '';
          });

          const choice = panel.querySelector('[data-role="choice"]');
          if (choice) {
            choice.textContent = this.optionNames
              .map((name) => set.opts[name])
              .filter(Boolean)
              .join(' · ');
          }
        });
      }
    }

    showError(msg) {
      const el = this.querySelector('[data-role="error"]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      clearTimeout(this.errTimer);
      this.errTimer = setTimeout(() => { el.hidden = true; }, 5000);
    }

    async addToCart() {
      const items = [];
      for (let i = 0; i < this.qty; i++) {
        const set = this.sets[i];
        const v = set ? this.variantFor(set.opts) : null;
        if (!v) {
          this.showError('That combination is not available. Check each set.');
          return;
        }
        items.push({ id: v.id, quantity: 1 });
      }

      const container = this.form ? this.form.querySelector('add-to-cart-component') : null;
      if (container && container.disable) container.disable();

      const body = { items };
      const sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach((el) => {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      if (sectionIds.length) body.sections = sectionIds.join(',');

      const url =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
          credentials: 'same-origin',
        });
        const data = await res.json();
        if (data.status) {
          this.showError(data.description || data.message || 'Could not add to cart.');
          return;
        }

        // The store's cart UX is the Slide Cart app drawer. Refresh it and open it
        // through its public API when present.
        try {
          if (typeof window.SLIDECART_UPDATE === 'function') await window.SLIDECART_UPDATE();
        } catch (e) { /* drawer refresh is best effort */ }
        try {
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        } catch (e) { /* drawer open is best effort */ }

        // Same event contract as the theme's own product form, so the cart icon
        // bubble and any cart sections update without their code involved.
        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: {},
          sourceId: (this.formComponent && this.formComponent.id) || 'linen-bundle-ladder',
          data: {
            source: 'product-form-component',
            itemCount: items.length,
            productId: this.formComponent ? this.formComponent.dataset.productId : undefined,
            sections: data.sections,
          },
        };
        (this.formComponent || this).dispatchEvent(ev);

        if (this.dataset.afterAdd === 'cart') {
          window.location.href = '/cart';
        }
      } catch (e) {
        this.showError('Could not add to cart. Try again.');
      } finally {
        if (container && container.enable) container.enable();
      }
    }
  }

  if (!customElements.get('linen-bundle-ladder')) {
    customElements.define('linen-bundle-ladder', LinenBundleLadder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linen-shipping-countdown"] && !Shopify.designMode) return;
  try {
    class LinenShippingCountdown extends HTMLElement {
    connectedCallback() {
      this.el = this.querySelector('[data-role="timer"]');
      if (!this.el) return;
      this.tz = this.dataset.tz || 'America/Los_Angeles';
      this.cutoff = parseInt(this.dataset.cutoff, 10);
      if (isNaN(this.cutoff) || this.cutoff < 1 || this.cutoff > 24) this.cutoff = 24;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    tick() {
      let now;
      try {
        now = new Date(new Date().toLocaleString('en-US', { timeZone: this.tz }));
      } catch (e) {
        now = new Date();
      }
      const next = new Date(now);
      if (this.cutoff === 24 || now.getHours() < this.cutoff) {
        next.setHours(this.cutoff, 0, 0, 0);
      } else {
        next.setDate(next.getDate() + 1);
        next.setHours(this.cutoff, 0, 0, 0);
      }
      const d = Math.max(0, next - now);
      const h = Math.floor(d / 3600000);
      const m = Math.floor((d % 3600000) / 60000);
      const sec = Math.floor((d % 60000) / 1000);
      this.el.textContent =
        (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
    }
  }

  if (!customElements.get('linen-shipping-countdown')) {
    customElements.define('linen-shipping-countdown', LinenShippingCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linen-stat-grid"] && !Shopify.designMode) return;
  try {
    class LinenStatGrid extends HTMLElement {
  connectedCallback() {
    if (this.dataset.animate !== 'true' || this._bound) return;
    this._bound = true;
    const vals = Array.from(this.querySelectorAll('.ln-stats__val'));
    if (!vals.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      vals.forEach((el) => (el.textContent = el.dataset.target));
      return;
    }
    const dur = parseInt(this.dataset.duration, 10) || 1400;
    const run = () => {
      const t0 = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - t0) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        vals.forEach((el) => {
          const target = parseFloat(el.dataset.target) || 0;
          el.textContent = Math.round(target * eased);
        });
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            run();
            obs.disconnect();
          }
        });
      },
      { threshold: 0.35 }
    );
    io.observe(this);
  }
}
if (!customElements.get('linen-stat-grid')) customElements.define('linen-stat-grid', LinenStatGrid);
  } catch(e) { console.error(e); }
})();

})();
